<script>
// Editar time virou uma pagina so (nome, descricao e participantes): o
// assistente de 3 passos obrigava a passar por participantes e por uma tela de
// conclusao para trocar so a descricao.
export default {};
</script>

<template>
  <div class="flex flex-col gap-6 mb-8 max-w-7xl mx-auto w-full !px-6">
    <div
      class="grid grid-cols-1 lg:grid-cols-8 rounded-2xl border border-n-weak h-full min-h-[50dvh] w-full"
    >
      <router-view />
    </div>
  </div>
</template>
